/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S31_TitleInputs */

const es_privacy_policy_data_collected_s31_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.1 Informacion que nos proporciona directamente`)
};

const en_privacy_policy_data_collected_s31_title = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.1 Information You Provide Directly`)
};

/**
* | output |
* | --- |
* | "3.1 Information You Provide Directly" |
*
* @param {Privacy_Policy_Data_Collected_S31_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s31_title = /** @type {((inputs?: Privacy_Policy_Data_Collected_S31_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S31_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s31_title(inputs)
	return en_privacy_policy_data_collected_s31_title(inputs)
});
export { privacy_policy_data_collected_s31_title as "privacy_policy.data_collected.s31_title" }